import Resource from '@/api/resource'
import request from '@/utils/request'
import store from '@/store/index'

class Images extends Resource {
  constructor() {
    super('images')
  }

  delete(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'delete',
    })
  }
}

export { Images as default }
